import { APIAuthClient as http } from 'service/apicataleg/api/APIHttpClient';
import { AddressDTO, ClientDTO, MarcaDTO } from 'service/apicataleg/types/ApiCatalegTypes';

export type ReqRegisterClient = {
  dni: string;
  rao: string;
  estab: string;
  email: string;
  dir1: string;
  pob1: string;
  pro1: string;
  cop1: string;
  pais1: string;
  iban: string;
  fp: number;
  tel: string;
  marques: Array<string>;
};

export type SuccessRegisterResponse = {
  client: ClientDTO;
  marques: Array<MarcaDTO>;
};

const RepresentantService = {
  async getMarques(): Promise<Array<MarcaDTO>> {
    try {
      const { data } = await http.get<Array<MarcaDTO>>('/representant/marques');
      return data;
    } catch (error) {
      return [];
    }
  },

  async getClientWithCif(cif: string): Promise<Array<ClientDTO>> {
    const { data } = await http.get(`/representant/clients/cif/${cif}`);
    return data;
  },

  async queryClients(query: string): Promise<Array<ClientDTO>> {
    try {
      const { data } = await http.get(`/representant/clients/search?query=${query}`);
      return data;
    } catch (error) {
      return [];
    }
  },

  async getClientById(id: number): Promise<ClientDTO | null> {
    try {
      const { data } = await http.get(`/representant/clients/${id}`);
      return data;
    } catch (error) {
      return null;
    }
  },

  async registerClient(values: ReqRegisterClient): Promise<SuccessRegisterResponse | null> {
    try {
      const { data } = await http.post(`/representant/clients/add`, values);
      return data;
    } catch (error) {
      return null;
    }
  },

  async getClientAddresses(idClient: number): Promise<Array<AddressDTO>> {
    try {
      const { data } = await http.get(`/representant/clients/${idClient}/address`);
      return data;
    } catch (error) {
      return [];
    }
  },

  async addClientAddress(id: number, address: AddressDTO): Promise<AddressDTO | null> {
    try {
      const { data } = await http.post(`/representant/clients/${id}/address`, address);
      return data;
    } catch (error) {
      return null;
    }
  },

  async updateClientAddress(client: number, address: AddressDTO): Promise<boolean> {
    try {
      await http.put(`/representant/clients/${client}/address/${address.codi}`, address);
      return true;
    } catch (error) {
      return false;
    }
  },

  async getClientMarques(client: number): Promise<Array<MarcaDTO>> {
    try {
      const { data } = await http.get(`/representant/clients/${client}/climarques`);
      return data;
    } catch (error) {
      return [];
    }
  },
};

export default RepresentantService;
